import axios from 'axios';
import { Baseurl } from './Baseurl';

// Get authentication token
const getAuthHeaders = () => {
  const token = localStorage.getItem('medtoken');
  return { Authorization: `Bearer ${token}` };
};

// Get current moderator's analysis (personal dashboard)
export const getCurrentModeratorAnalysis = async (moderatorId) => {
  const response = await axios.get(`${Baseurl}/module-moderator-analysis/moderators/${moderatorId}/analysis`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

// Get current moderator's modules by grade
export const getCurrentModeratorModulesByGrade = async (moderatorId, grade = null) => {
  const params = grade ? { grade } : {};
  const response = await axios.get(`${Baseurl}/module-moderator-analysis/moderators/${moderatorId}/modules`, { 
    params,
    headers: getAuthHeaders()
  });
  return response.data;
};

// Get content analysis for a specific module
export const getModuleContentAnalysis = async (moduleId) => {
  const response = await axios.get(`${Baseurl}/module-moderator-analysis/modules/${moduleId}/content-analysis`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

// Get all module moderators with their assigned modules (for admin view)
export const getAllModeratorsWithModules = async () => {
  const response = await axios.get(`${Baseurl}/module-moderator-analysis/moderators`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

// Get detailed analysis for a specific moderator (for admin view)
export const getModeratorAnalysis = async (moderatorId) => {
  const response = await axios.get(`${Baseurl}/module-moderator-analysis/moderators/${moderatorId}/analysis`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

// Get module status distribution for all moderators (for admin view)
export const getModuleStatusDistribution = async () => {
  const response = await axios.get(`${Baseurl}/module-moderator-analysis/status-distribution`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

// Get overall statistics for all moderators (for admin view)
export const getOverallStatistics = async () => {
  const response = await axios.get(`${Baseurl}/module-moderator-analysis/statistics`, {
    headers: getAuthHeaders()
  });
  return response.data;
};
